import { useRedirectCountdown } from '@/hooks/useRedirectCountdown';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { AnimatedIcon } from './AnimatedIcon';
import { ConfettiCanvas } from './ConfettiCanvas';
import { DashboardButton } from './DashboardButton';
import { RedirectMessage } from './RedirectMessage';
import { WelcomeHeading } from './WelcomeHeading';
import { WelcomeText } from './WelcomeText';
import { CheckCircle } from 'iconoir-react';

interface SuccessStateProps {
  onRedirect: () => void;
}

export const SuccessState: React.FC<SuccessStateProps> = ({ onRedirect }) => {
  const { t } = useTranslation();

  const remainingSeconds = useRedirectCountdown({
    initialSeconds: 5,
    onComplete: onRedirect,
  });

  return (
    <>
      <ConfettiCanvas trigger={true} />
      <AnimatedIcon icon={<CheckCircle width={48} height={48} />} animation="scaleIn" />
      <WelcomeHeading fadeDelay={0.2}>{t('welcome.shopify.success.title')}</WelcomeHeading>
      <WelcomeText fadeDelay={0.4}>{t('welcome.shopify.success.subtitle')}</WelcomeText>
      <RedirectMessage seconds={remainingSeconds} fadeDelay={0.6} />
      <DashboardButton onClick={onRedirect} fadeDelay={0.8} />
    </>
  );
};
